/**
 * Centralized demo isolation filter.
 * 
 * Applies `.eq('is_demo', isDemoUser)` to any Supabase query builder
 * that touches marketplace tables (loads, truck_postings, direct_loads, direct_bids).
 * 
 * RLS policies already enforce isolation at the DB level as a safety net.
 * This filter provides explicit client-side enforcement for clarity and
 * ensures realtime event filtering works correctly.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function applyDemoFilter<T extends Record<string, any>>(
  query: T,
  isDemoUser: boolean,
): T {
  return (query as any).eq('is_demo', isDemoUser) as T;
}
